import React from 'react';
import Chart from 'react-apexcharts';

import { colors } from 'styles';

interface IProps {
  options?: any;
  data: number;
  label?: string;
}

const TemperatureChart: React.FC<IProps> = ({ data, label }) => {
  const options = {
    series: [data],
    chart: {
      width: '120%',
      type: 'radialBar',
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: '70%',
          background: '#fff',
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: 'front',
        },
        track: {
          background: '#fff',
          strokeWidth: '85%',
          margin: 0, // margin is in pixels
        },
        dataLabels: {
          show: true,
          name: {
            show: true,
            fontFamily: 'Montserrat',
            fontSize: '1rem',
            color: colors.textGrey3e,
            fontWight: 'bold',
          },
          value: {
            formatter: function (val: any) {
              return `${val.toFixed(1)}%`;
            },
            show: true,
            fontFamily: 'Montserrat',
            fontSize: '2rem',
            color: colors.textGrey3e,
            fontWeight: '900',
          },
        },
      },
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: [colors.blueBrand],
        inverseColors: true,
        opacityFrom: 0.7,
        opacityTo: 1,
        stops: [0, 40],
      },
    },
    stroke: {
      lineCap: 'straight',
    },
    labels: [label],
  };

  return (
    <>
      <Chart series={options.series} options={options} type="radialBar" />
    </>
  );
};

export default TemperatureChart;
